import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useApp } from "@/context/AppContext";

export default function ProductCard({ product, index = 0 }) {
  const { addToCart } = useApp();
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, delay: (index % 4) * 0.08 }}
      className="group"
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/product/${product.id}`} className="block">
        <div className="relative aspect-[3/4] overflow-hidden bg-neutral-100">
          <img
            src={product.image + "?auto=format&fit=crop&w=800&q=80"}
            alt={product.name}
            className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute top-3 left-3 font-mono-brand text-[10px] uppercase tracking-[0.2em] text-white bg-black/60 backdrop-blur px-2 py-1">
            {product.category}
          </div>
        </div>
      </Link>
      <div className="pt-4 pb-2 flex items-start justify-between gap-4">
        <div>
          <Link to={`/product/${product.id}`}>
            <h3 className="font-display text-lg font-medium leading-tight hover:text-[#FF3B30] transition-colors">
              {product.name}
            </h3>
          </Link>
          <div className="font-mono-brand text-xs text-neutral-500 mt-1">
            ${product.price.toFixed(2)}
          </div>
        </div>
        <button
          onClick={(e) => { e.preventDefault(); addToCart(product.id, 1); }}
          className="font-mono-brand text-[10px] uppercase tracking-[0.2em] border-b border-black hover:border-[#FF3B30] hover:text-[#FF3B30] transition-colors pb-0.5"
          data-testid={`product-add-${product.id}`}
        >
          Add
        </button>
      </div>
    </motion.div>
  );
}
